import { memo, type RefObject } from 'react';

import { getWorkspaceAgentSelectAssetEmptyCopy } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/getWorkspaceAgentSelectAssetEmptyCopy';
import { useWorkspaceAgentSelectAssetStore } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/WorkspaceAgentSelectAssetStoreContext';
import { WorkspaceAgentSelectAssetVirtualList } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/WorkspaceAgentSelectAssetVirtualList';

export type WorkspaceAgentSelectAssetBoardPickerListProps = {
  listRef: RefObject<HTMLDivElement>;
};

export const WorkspaceAgentSelectAssetBoardPickerList = memo(
  ({ listRef }: WorkspaceAgentSelectAssetBoardPickerListProps) => {
    const results = useWorkspaceAgentSelectAssetStore((state) => state.boardResults);
    const query = useWorkspaceAgentSelectAssetStore((state) => state.boardPickerQuery);
    const source = useWorkspaceAgentSelectAssetStore((state) => state.source);
    const highlightedIndex = useWorkspaceAgentSelectAssetStore((state) => state.boardHighlightedIndex);
    const isKeyboardHighlight = useWorkspaceAgentSelectAssetStore((state) => state.isBoardKeyboardHighlight);
    const onHighlight = useWorkspaceAgentSelectAssetStore((state) => state.highlightBoard);
    const onSelectItem = useWorkspaceAgentSelectAssetStore((state) => state.selectItemById);
    const hasRows = results.items.length > 0;
    const emptyStateTitle = getWorkspaceAgentSelectAssetEmptyCopy({
      hasFailed: results.isError && !hasRows,
      isBoardPickerOpen: true,
      query,
      source,
    });

    const listPaginationKey = `board-picker|${query}`;

    return (
      <WorkspaceAgentSelectAssetVirtualList
        ariaLabel="Choose board"
        emptyStateTitle={emptyStateTitle}
        highlightedIndex={highlightedIndex}
        isKeyboardHighlight={isKeyboardHighlight}
        listPaginationKey={listPaginationKey}
        listRef={listRef}
        onHighlight={onHighlight}
        onSelectItem={onSelectItem}
        results={results}
        role="tree"
      />
    );
  },
);

WorkspaceAgentSelectAssetBoardPickerList.displayName = 'WorkspaceAgentSelectAssetBoardPickerList';
